import type { KonvaEventObject as KonvaEventObjectType } from 'konva/lib/Node';
import {
  MAX_SCALE,
  MIN_SCALE,
  SF_PDF,
  SF_IMG,
} from '../../../constants/parameters';
import { Layer } from 'konva/lib/Layer';
export const useCanvasInteractions = (
  documentType: string,
  scale: number,
  setScale: (scale: number) => void,
  setPosition: (pos: { x: number; y: number }) => void,
  setPositionPDF: (pos: { x: number; y: number }) => void,
  offset: { x: number; y: number }
) => {
  const handleMouseEnter = (e: KonvaEventObjectType<MouseEvent>) => {
    const container = e.target.getStage()?.container();
    if (container) {
      container.style.cursor = 'move';
    }
  };

  const handleMouseLeave = (e: KonvaEventObjectType<MouseEvent>) => {
    const container = e.target.getStage()?.container();
    if (container) {
      container.style.cursor = 'default';
    }
  };

  const handleDragMove = (e: KonvaEventObjectType<DragEvent>) => {
    if (documentType === 'image') {
      return;
    }

    setPositionPDF({
      x: e.target.x() - offset.x * scale,
      y: e.target.y() - offset.y * scale,
    });
  };

  const handleWheel = (e: KonvaEventObjectType<WheelEvent>) => {
    const stage = e.target.getStage();
    const layer = e.target.getLayer() as Layer | null;
    if (!stage || !layer) return;

    const oldScale = layer.scaleX();
    const pointer = stage.getPointerPosition();

    if (!pointer) return;

    const mousePointTo: { x: number; y: number } = {
      x: (pointer.x - layer.x()) / oldScale,
      y: (pointer.y - layer.y()) / oldScale,
    };

    const direction = e.evt.deltaY > 0 ? -1 : 1;

    const scaleFactor = documentType === 'pdf' ? SF_PDF : SF_IMG;
    let newScale =
      direction > 0 ? oldScale * scaleFactor : oldScale / scaleFactor;

    if (newScale > MAX_SCALE) newScale = MAX_SCALE;
    if (newScale < MIN_SCALE) newScale = MIN_SCALE;

    const newPos = {
      x: pointer.x - mousePointTo.x * newScale,
      y: pointer.y - mousePointTo.y * newScale,
    };

    const newPosPDF = {
      x: pointer.x - mousePointTo.x * newScale - offset.x * newScale,
      y: pointer.y - mousePointTo.y * newScale - offset.y * newScale,
    };

    if (newScale !== oldScale) {
      setScale(newScale);
      setPosition(newPos);
      setPositionPDF(newPosPDF);
    }
  };

  return {
    handleMouseEnter,
    handleMouseLeave,
    handleDragMove,
    handleWheel,
  };
};
